import React from 'react';
import ReactDOM from 'react-dom/client';
import { createTheme, localStorageColorSchemeManager, MantineProvider } from '@mantine/core';
import { App } from './app/App';
import '@mantine/core/styles.css';
import './app/styles.css';

const theme = createTheme({
  primaryColor: 'violet',
  fontFamily: 'Inter, system-ui, sans-serif',
  headings: {
    fontFamily: 'Geist, sans-serif',
    fontWeight: '700',
  },
  fontFamilyMonospace: 'JetBrains Mono, monospace',
  defaultRadius: 'lg',
  colors: {
    // Customizing violet to match the primary #cfbcff
    violet: [
      '#f3edff',
      '#e9ddff',
      '#cfbcff', // primary
      '#b499ff',
      '#9876ff',
      '#7c53ff',
      '#6750a4', // inverse-primary / primary-container
      '#553f8a',
      '#432e70',
      '#321e57',
    ],
    // Customizing gray to match surfaces
    gray: [
      '#f9f9f9',
      '#e6e0e9', // on-surface
      '#cbc4d2', // on-surface-variant
      '#948e9c', // outline
      '#494551', // outline-variant
      '#36343a', // surface-variant
      '#2b292f', // surface-container-high
      '#211f24', // surface-container
      '#1d1b20', // surface-container-low
      '#141218', // surface
    ],
  },
  components: {
    Container: {
      defaultProps: {
        size: 'xl',
      },
    },
    Button: {
      defaultProps: {
        radius: 'xl',
      },
    },
    Badge: {
      defaultProps: {
        radius: 'xl',
      },
    },
  },
});

const compassColorSchemeManager = localStorageColorSchemeManager({
  key: 'compass.color-scheme',
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MantineProvider
      theme={theme}
      colorSchemeManager={compassColorSchemeManager}
      defaultColorScheme="dark"
    >
      <App />
    </MantineProvider>
  </React.StrictMode>,
);
